import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
  getRestrictedItemsStart,
  getUnRestrictedItemsStart,
  addRestrictedItemsStart,
  deleteRestrictedItemsStart
} from '../../../store/redux-slices/fetchData'
import { toast } from '../../../components/Toast'
import useDidMountEffect from '../../../utils/useDidMountEffect'

const useRestrictedGames = () => {
  const dispatch = useDispatch()
  const { countryId } = useParams()
  const navigate = useNavigate()

  const [selectedTab, setSelectedTab] = useState('restricted-games')
  const [selectedGames, setSelectedGames] = useState({ count: 0, rows: [] })
  const [removedGames, setRemovedGames] = useState({ count: 0, rows: [] })
  const [restrictedItemsLimit, setRestrictedItemsLimit] = useState(15)
  const [restrictedItemsPage, setRestrictedItemsPage] = useState(1)
  const [search, setSearch] = useState('')
  const [restrictedSearch, setRestrictedSearch] = useState('')

  const [unRestrictedItemsLimit, setUnRestrictedItemsLimit] = useState(15)
  const [unRestrictedItemsPage, setUnRestrictedItemsPage] = useState(1)
  const isInitialRender = useDidMountEffect()

  const { loading, restrictedItems, unRestrictedItems } = useSelector(state => state.fetch)

  const restrictedItemsTotalPages = Math.ceil(restrictedItems?.count / restrictedItemsLimit)
  const unRestrictedItemsTotalPages = Math.ceil(unRestrictedItems?.count / unRestrictedItemsLimit)

  useEffect(() => {
    dispatch(getRestrictedItemsStart({
      limit: restrictedItemsLimit,
      pageNo: restrictedItemsPage,
      type: 'games',
      countryId,
      search: restrictedSearch
    }))
  }, [restrictedItemsLimit, restrictedItemsPage])

  useEffect(() => {
    if (!isInitialRender) {
      const delayDebounceFn = setTimeout(() => {
        if (restrictedItemsPage === 1) {
          dispatch(getRestrictedItemsStart({
            limit: restrictedItemsLimit,
            pageNo: restrictedItemsPage,
            type: 'games',
            countryId,
            search: restrictedSearch
          }))
        } else {
          setRestrictedItemsPage(1)
        }
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    }
  }, [restrictedSearch])

  useEffect(() => {
    if (!isInitialRender) {
      const delayDebounceFn = setTimeout(() => {
        if (unRestrictedItemsPage === 1) {
          dispatch(getUnRestrictedItemsStart({
            limit: unRestrictedItemsLimit,
            pageNo: unRestrictedItemsPage,
            type: 'games',
            countryId,
            search
          }))
        } else {
          setUnRestrictedItemsPage(1)
        }
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    }
  }, [search])

  useEffect(() => {
    dispatch(getUnRestrictedItemsStart({
      limit: unRestrictedItemsLimit,
      pageNo: unRestrictedItemsPage,
      type: 'games',
      countryId,
      search
    }))
  }, [unRestrictedItemsLimit, unRestrictedItemsPage])

  const addGame = (game) => {
    const gameExists = ({ ...selectedGames }
      .rows
      .findIndex(g => g.casinoGameId === game.casinoGameId))

    if (gameExists === -1) {
      setSelectedGames({ count: selectedGames.count + 1, rows: [...selectedGames.rows, game] })
    } else {
      toast('Already added this game', 'error')
    }
  }

  const removeGame = (gameId) => {
    const updatedGameRows = [...selectedGames.rows].filter(g => g.casinoGameId !== gameId)
    setSelectedGames({ count: selectedGames.count - 1, rows: updatedGameRows })
  }

  const addRestrictedGames = () => {
    const games = [...selectedGames.rows].map(g => g.casinoGameId)

    dispatch(addRestrictedItemsStart({ type: 'games', games, countryId, navigate }))
  }

  const addDeleteGame = (game) => {
    const gameExists = ({ ...removedGames }
      .rows
      .findIndex(g => g.casinoGameId === game.casinoGameId))

    if (gameExists === -1) {
      setRemovedGames({ count: removedGames.count + 1, rows: [...removedGames.rows, game] })
    } else {
      toast('Already added this Game', 'error')
    }
  }

  const removeDeleteGame = (gameId) => {
    const updatedGameRows = [...removedGames.rows].filter(g => g.casinoGameId !== gameId)
    setRemovedGames({ count: removedGames.count - 1, rows: updatedGameRows })
  }

  const removeRestrictedGame = () => {
    const games = [...removedGames.rows].map(g => g.casinoGameId)
    dispatch(deleteRestrictedItemsStart({ type: 'games', games, countryId:Number(countryId), navigate }))
  }

  return {
    loading,
    restrictedItemsLimit,
    setRestrictedItemsLimit,
    restrictedItemsPage,
    setRestrictedItemsPage,
    unRestrictedItemsLimit,
    setUnRestrictedItemsLimit,
    setUnRestrictedItemsPage,
    unRestrictedItemsPage,
    restrictedItemsTotalPages,
    unRestrictedItemsTotalPages,
    restrictedItems,
    selectedTab,
    setSelectedTab,
    unRestrictedItems,
    addGame,
    selectedGames,
    removeGame,
    addRestrictedGames,
    addDeleteGame,
    removeDeleteGame,
    removeRestrictedGame,
    removedGames,
    search,
    setSearch,
    restrictedSearch,
    setRestrictedSearch
  }
}

export default useRestrictedGames
